import { render, staticRenderFns } from "./OTPContent.vue?vue&type=template&id=48569290&"
import script from "./OTPContent.vue?vue&type=script&lang=js&"
export * from "./OTPContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports